import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import './App.css';
import Layout from './components/Layout';
import LoginPage from './components/LoginPage';
import HomePage from './components/HomePage';
import ReportEmbed from './components/ReportEmbed';
import Genie from './components/Genie';
import useAuth from './hooks/useAuth';
import { useReports } from './hooks/useReports';
import LoadingSpinner from './components/LoadingSpinner';
import Header from './components/Header';
import Footer from './components/Footer';
import apiClient from './services/api';

function App() {
  const { isLoggedIn, loading: authLoading } = useAuth();
  const { reportTitles, loading: reportsLoading } = useReports();
  const location = useLocation();
  const [version, setVersion] = useState('');

  useEffect(() => {
    apiClient.get('/version')
      .then(response => {
        if (response.data.version) {
          setVersion(response.data.version);
        }
      })
      .catch(err => console.error('Failed to fetch version', err));
  }, []);

  useEffect(() => {
    let title = "ADAP";
    if (reportsLoading) {
      // Don't set a specific title until report data is loaded
    } else if (location.pathname === '/genie') {
      title += " - Genie";
    } else if (location.pathname.startsWith('/report/')) {
      const reportId = location.pathname.split('/').pop();
      if (reportId && reportTitles[reportId]) {
        title += ` - ${reportTitles[reportId]}`;
      } else {
        title += " - Report";
      }
    } else if (location.pathname === '/') {
        title += " - Home";
    }
    document.title = title;
  }, [location.pathname, reportTitles, reportsLoading]);

  if (authLoading || reportsLoading) {
    return <LoadingSpinner text="Initializing ADAP..." />;
  }

  return (
    <>
      <Header />
      <main className="main-flex">
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route element={isLoggedIn ? <Layout /> : <Navigate to="/login" replace />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/report/:reportId" element={<ReportEmbed />} />
            <Route path="/genie" element={<Genie />} />
            {/* Any other protected routes will be nested here */}
          </Route>
          {/* Catch-all for any unknown routes, redirect to home or login */}
          <Route path="*" element={isLoggedIn ? <Navigate to="/" replace /> : <Navigate to="/login" replace />} />
        </Routes>
      </main>
      <Footer version={version} />
    </>
  );
}

export default App;

